import React from "react";

import { TradeVerticalPage } from "../../../components/admin/u1/trade/TradeVerticalPage";
import { TRADE_VERTICALS } from "../../../constants/tradeVerticals";
import "../../../components/common/u1/tokens.css";

/* u1 Trade Information — previewed at /u1/dashboard/trade-information. */
const TradeInformation = () => <TradeVerticalPage config={TRADE_VERTICALS.information} />;

export default TradeInformation;
